var React = require('react');

function AddWhite (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Group"),React.createElement("g",{"id":"//-Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":1},React.createElement("g",{"id":"icons/Navigation/Add","transform":"translate(-4.000000, -3.000000)","stroke":"#FFFFFF","strokeWidth":"2"},React.createElement("g",{"id":"Group","transform":"translate(5.500000, 4.919242)"},[React.createElement("line",{"x1":"7","y1":"0","x2":"7","y2":"14","id":"Line-2-Copy-4","key":0}),React.createElement("line",{"x1":"7","y1":"0.0807577268","x2":"7","y2":"14.0807577","id":"Line-2-Copy-4","transform":"translate(7.000000, 7.080758) rotate(-90.000000) translate(-7.000000, -7.080758) ","key":1})])))]);
}

AddWhite.defaultProps = {"width":"17px","height":"17px","viewBox":"0 0 17 17","version":"1.1"};

module.exports = AddWhite;

AddWhite.default = AddWhite;
